import { Box, Checkbox, MenuItem, Select, SelectChangeEvent, Typography } from "@mui/material";
import { UseFormSetValue } from "react-hook-form";
import { useTranslation } from "react-i18next";

interface CompanyBalanceSelectorItemProps {
	fieldName: string;
	value: number[];
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	setValue: UseFormSetValue<any>;
	companyBalances: { id: number; value: string }[];
	error?: string;
}

export default function CompanyBalanceSelectorItem({
	fieldName,
	value = [],
	setValue,
	companyBalances,
	error,
}: CompanyBalanceSelectorItemProps) {
	const { t } = useTranslation();
	const ts = (key: string) => t(`manage-questionnaire.${key}`);

	const handleChange = (event: SelectChangeEvent<number[]>) => {
		const selected = event.target.value as number[];

		setValue(fieldName, selected, {
			shouldValidate: true,
			shouldDirty: true,
		});
	};

	return (
		<Select
			displayEmpty
			fullWidth
			multiple
			error={!!error}
			renderValue={(selected: unknown) =>
				Array.isArray(selected) && selected.length > 0
					? selected
							.map((id) => companyBalances.find((i) => i.id === id)?.value)
							.filter(Boolean)
							.join(", ")
					: ts("select-company-balance")
			}
			value={value}
			onChange={handleChange}
		>
			{companyBalances.map((companyBalance) => (
				<MenuItem key={companyBalance.id} value={companyBalance.id}>
					<Box sx={{ display: "flex", alignItems: "center", gap: 1, width: "100%" }}>
						<Checkbox checked={value.includes(companyBalance.id)} sx={{ padding: "4px" }} />
						<Typography component="span" sx={{ m: 0 }}>
							{companyBalance.value}
						</Typography>
					</Box>
				</MenuItem>
			))}
		</Select>
	);
}
